(() => {
  const HOST_SELECTOR = '.product-wishlist, .sticky-atc__wishlist';
  const BUTTON_TAG = 'xb-wishlist-button-collection';
  const NOTIP_FLAG = 'data-pdp-wishlist-notip';

  const isWishlisted = (button) => {
    if (!(button instanceof HTMLElement)) return false;
    const root = button.shadowRoot || button;
    if (root.querySelector('.xb-wishlist-button-collection__remove')) return true;
    if (root.querySelector('.xb-wishlist-button-collection__add')) return false;
    return button.classList.contains('is-active') || button.hasAttribute('active');
  };

  const syncHost = (host) => {
    const button = host.querySelector(BUTTON_TAG);
    if (!button) {
      host.classList.remove('is-wishlisted');
      return;
    }
    host.classList.toggle('is-wishlisted', isWishlisted(button));
  };

  /* 与商品卡一致：应用用外层 span 的 mousemove 出气泡，捕获阶段截断即可 */
  const muteTooltip = (el) => {
    if (!(el instanceof HTMLElement) || el.hasAttribute(NOTIP_FLAG)) return;
    el.setAttribute(NOTIP_FLAG, '');
    el.addEventListener('mousemove', (event) => event.stopPropagation(), true);
    el.removeAttribute('title');
    el.removeAttribute('data-tooltip');
  };

  const observeHost = (host) => {
    if (!(host instanceof HTMLElement) || host.hasAttribute('data-pdp-wishlist-bound')) return;
    host.setAttribute('data-pdp-wishlist-bound', '');

    const sync = () => syncHost(host);
    sync();
    muteTooltip(host);

    host.addEventListener(
      'click',
      () => {
        /* 点击即时切到目标态，等应用确认后由 MutationObserver 校正 */
        host.classList.toggle('is-wishlisted', !host.classList.contains('is-wishlisted'));
      },
      true
    );

    const bindButton = (button) => {
      if (!(button instanceof HTMLElement) || button.hasAttribute('data-pdp-wishlist-watch')) return;
      button.setAttribute('data-pdp-wishlist-watch', '');
      muteTooltip(button);
      new MutationObserver(sync).observe(button, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'active']
      });
      if (button.shadowRoot) {
        new MutationObserver(sync).observe(button.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
      sync();
    };

    const button = host.querySelector(BUTTON_TAG);
    if (button) bindButton(button);

    new MutationObserver(() => {
      const next = host.querySelector(BUTTON_TAG);
      if (next) bindButton(next);
      sync();
    }).observe(host, { childList: true, subtree: true });
  };

  const scan = () => {
    document.querySelectorAll(HOST_SELECTOR).forEach(observeHost);
  };

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  if (window.customElements?.whenDefined) {
    customElements.whenDefined(BUTTON_TAG).then(scan).catch(() => {});
  }
})();

(() => {
  const TOAST_SELECTOR = '.xb-wishlist-notification';
  const FILLED_FLAG = 'data-toast-image-filled';
  const LOGIN_FLAG = 'data-toast-login-link';
  let lastMedia = null;

  const loginUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}account/login`;
  };

  /* XB Wishlist 免费版只能配一种语言：插件后台保持英文，这里按英文开头认出是哪条再换成当前语言。
     插件后台改了英文开头，下面的匹配要跟着改，否则会回退成英文。 */
  const TOAST_RULES = [
    ['guestAdded', (text) => text.startsWith('item has been temporarily added')],
    ['added', (text) => text.startsWith('item has been successfully added')],
    ['removed', (text) => text.startsWith('item has been successfully removed')],
    ['addedToCart', (text) => text.startsWith('item added to your cart')],
    ['linkCopied', (text) => text.startsWith('wishlist url copied')],
    ['savedForLater', (text) => text.startsWith('save for later successfully')],
    ['removedSaveForLater', (text) => text.startsWith('remove from save for later')],
    ['maxQuantity', (text) => text.startsWith('the maximum quantity of this item')],
    ['notFound', (text) => text.startsWith('product details not found')],
    ['moved', (text) => text.includes(' has been moved to another wishlist')]
  ];
  const TRANSLATED_ATTR = 'data-toast-translated';

  const translateToast = (toast) => {
    const strings = window.themeVariables?.strings?.wishlistToast;
    if (!strings) return;

    const message = toast.querySelector('.xb-wishlist-notification__message');
    if (!(message instanceof HTMLElement)) return;

    const original = (message.textContent || '').replace(/\s+/g, ' ').trim();
    if (!original || message.getAttribute(TRANSLATED_ATTR) === original) return;

    const rule = TOAST_RULES.find(([, test]) => test(original.toLowerCase()));
    const translated = rule && strings[rule[0]];
    if (!translated) return;

    if (rule[0] === 'guestAdded') {
      message.innerHTML = translated;
      message.querySelector('a')?.classList.add('link-elastic-reverse');
      message.setAttribute(LOGIN_FLAG, '');
    } else if (rule[0] === 'moved') {
      const product = original.slice(0, original.toLowerCase().indexOf(' has been moved to another wishlist'));
      message.textContent = translated.replace('__PRODUCT__', product);
    } else {
      message.textContent = translated;
    }

    message.setAttribute(TRANSLATED_ATTR, (message.textContent || '').replace(/\s+/g, ' ').trim());
  };

  /* 稿 1552:153525：please <a>login to</a> save…，下划线只包这两词 */
  const decorateGuestLoginLink = (toast) => {
    const message = toast.querySelector('.xb-wishlist-notification__message');
    if (!(message instanceof HTMLElement) || message.hasAttribute(LOGIN_FLAG)) return;

    const link = message.querySelector('a');
    if (!link) return;

    message.setAttribute(LOGIN_FLAG, '');
    link.href = loginUrl();
    link.classList.add('link-elastic-reverse');

    const next = link.nextSibling;
    if (next && next.nodeType === Node.TEXT_NODE && /^\s*to\b/i.test(next.textContent || '')) {
      next.textContent = (next.textContent || '').replace(/^\s*to\b/i, '');
      if (!/\bto$/i.test(link.textContent.trim())) {
        link.textContent = `${link.textContent.trim()} to`;
      }
    }
  };

  const decodeXb = (raw) => {
    if (!raw) return null;
    try {
      const value = raw.startsWith('___xb___:') ? raw.slice(9) : raw;
      return JSON.parse(value.startsWith('{') || value.startsWith('[') ? value : atob(value));
    } catch (error) {
      return null;
    }
  };

  const parseJson = (raw, fallback) => {
    try {
      const value = JSON.parse(raw);
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  };

  const imageFromPreview = (handle) => {
    if (!handle) return '';
    const preview = decodeXb(localStorage.getItem('xb_multi_wishlist_preview_image'));
    if (!preview || typeof preview !== 'object') return '';
    return Object.values(preview)
      .flatMap((list) => (Array.isArray(list) ? list : []))
      .find((item) => item?.handle === handle)?.imageUrl || '';
  };

  const fromImg = (img) => {
    if (!(img instanceof HTMLImageElement)) return null;
    const src = img.currentSrc || img.src || '';
    if (!src) return null;
    return { src: src, alt: img.alt || '' };
  };

  /* 画廊按色过滤后，hidden 的是别的 SKC；可见组里优先当前色的 featured */
  const visibleGalleryMedia = (root) => {
    if (!root) return null;
    const cells = [...root.querySelectorAll('.product-gallery__media')].filter(
      (node) => !node.hasAttribute('hidden')
    );
    const initial = cells.find((node) => node.classList.contains('is-initial'));
    return fromImg((initial || cells[0])?.querySelector('img'));
  };

  const imageFromWishlistCard = (card) => {
    const variantId = card.getAttribute('data-variant-id');
    const variants = parseJson(card.querySelector('[data-variants]')?.textContent, []);
    const variant = Array.isArray(variants)
      ? variants.find((item) => item && String(item.id) === String(variantId))
      : null;
    if (variant?.image) {
      return { src: variant.image, alt: card.querySelector('.wishlist-card__image')?.alt || '' };
    }
    return fromImg(card.querySelector('img.wishlist-card__image'));
  };

  const handleFrom = (el) =>
    el.closest('[xb-handle]')?.getAttribute('xb-handle') ||
    el.closest('cart-wishlist-move')?.querySelector('[xb-handle]')?.getAttribute('xb-handle') ||
    el.querySelector?.('[xb-handle]')?.getAttribute('xb-handle') ||
    '';

  const imageFromContext = (el) => {
    if (!(el instanceof Element)) return null;

    const wishlistCard = el.closest('wishlist-card');
    if (wishlistCard) {
      const media = imageFromWishlistCard(wishlistCard);
      if (media?.src) return media;
    }

    const productCard = el.closest('product-card');
    if (productCard) {
      const media = fromImg(
        productCard.querySelector('.product-card__cover img') ||
          productCard.querySelector('.product-card__image.is-active') ||
          productCard.querySelector('.product-card__image')
      );
      if (media?.src) return media;
    }

    const cartRoot = el.closest('.cart-row, line-item, .line-item');
    if (cartRoot) {
      const media = fromImg(
        cartRoot.querySelector('.cart-row__image') || cartRoot.querySelector('.line-item__media img')
      );
      if (media?.src) return media;
    }

    const quickBuy = el.closest('.quick-buy, quick-buy-modal, .modal--quick-buy');
    if (quickBuy) {
      const media = fromImg(quickBuy.querySelector('.quick-buy__product-image')) || visibleGalleryMedia(quickBuy);
      if (media?.src) return media;
    }

    if (el.closest('.product, .product-wishlist, product-sticky-add-to-cart, .sticky-atc__wishlist')) {
      const scope = el.closest('.product') || document.querySelector('.product');
      const media = visibleGalleryMedia(scope);
      if (media?.src) return media;
    }

    const handle = handleFrom(el);
    const preview = imageFromPreview(handle);
    if (preview) return { src: preview, alt: handle };

    return visibleGalleryMedia(document.querySelector('.product'));
  };

  const captureMedia = (el) => {
    const media = imageFromContext(el);
    if (media?.src) lastMedia = media;
  };

  window.__tiemcoWishlistToastMedia = {
    set(media) {
      if (media?.src) lastMedia = { src: media.src, alt: media.alt || '' };
    },
  };

  const fillToast = (toast) => {
    if (!(toast instanceof HTMLElement)) return;
    if (toast.querySelector('.xb-wishlist-notification__product img')) {
      toast.setAttribute(FILLED_FLAG, '');
      return;
    }

    const status = toast.querySelector('.xb-wishlist-notification__icon-status');
    if (!status || !lastMedia?.src) return;

    toast.setAttribute(FILLED_FLAG, '');
    const wrap = document.createElement('div');
    wrap.className = 'xb-wishlist-notification__product';
    const image = document.createElement('img');
    image.src = lastMedia.src;
    image.alt = lastMedia.alt || '';
    wrap.appendChild(image);
    status.replaceWith(wrap);
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(
        'xb-wishlist-button-collection, [data-cart-wishlist-trigger], [data-wishlist-remove]'
      );
      if (!trigger) return;
      captureMedia(trigger);
    },
    true
  );

  /* 心愿页会先派 xb-wishlist:remove 再删卡，这里趁卡片还在把图留下给随后的 toast */
  document.addEventListener('xb-wishlist:remove', (event) => {
    const id = event.detail && event.detail.productId;
    const variantId = event.detail && event.detail.variantId;
    if (!id) return;
    const card = variantId
      ? document.querySelector(`wishlist-card[data-product-id="${id}"][data-variant-id="${variantId}"]`) ||
        document.querySelector(`wishlist-card[data-product-id="${id}"], [data-product-id="${id}"]`)
      : document.querySelector(`wishlist-card[data-product-id="${id}"], [data-product-id="${id}"]`);
    if (card) captureMedia(card);
  });

  const scanToasts = () => {
    document.querySelectorAll(TOAST_SELECTOR).forEach((toast) => {
      fillToast(toast);
      translateToast(toast);
      decorateGuestLoginLink(toast);
    });
  };
  scanToasts();
  new MutationObserver(scanToasts).observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const TOAST_TOP_VAR = '--wishlist-toast-top';
  const HEADER_GROUP = '.shopify-section-group-header-group';
  let raf = 0;
  let followRaf = 0;

  /* 从视口顶部往下，量当前贴在一起的 header-group（公告条 / 倒计时 / 导航）底边。
     toast 已盖在小购物车之上，打开抽屉时不要改锚到抽屉标题，否则会跳一下。 */
  const measureHeaderStackBottom = () => {
    const rects = Array.from(document.querySelectorAll(HEADER_GROUP))
      .map((el) => el.getBoundingClientRect())
      .filter((rect) => rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight)
      .sort((a, b) => a.top - b.top);

    let bottom = 0;
    for (const rect of rects) {
      if (rect.top > bottom + 1) break;
      bottom = Math.max(bottom, rect.bottom);
    }
    return Math.max(0, Math.round(bottom));
  };

  const syncToastTop = () => {
    document.documentElement.style.setProperty(TOAST_TOP_VAR, `${measureHeaderStackBottom()}px`);
  };

  const scheduleSync = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      syncToastTop();
    });
  };

  /* 导航 hide-on-scroll 有 0.2s transform，跟帧贴住底边 */
  const followHeaderMotion = () => {
    cancelAnimationFrame(followRaf);
    const start = performance.now();
    const tick = (now) => {
      syncToastTop();
      if (now - start < 280) followRaf = requestAnimationFrame(tick);
    };
    followRaf = requestAnimationFrame(tick);
  };

  const observeDrawer = (drawer) => {
    if (!(drawer instanceof HTMLElement) || drawer.hasAttribute('data-wishlist-toast-watch')) return;
    drawer.setAttribute('data-wishlist-toast-watch', '');
    new MutationObserver(scheduleSync).observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  };

  syncToastTop();
  observeDrawer(document.getElementById('cart-drawer'));

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('dialog:after-show', scheduleSync);
  document.addEventListener('dialog:after-hide', scheduleSync);
  document.addEventListener('cart-drawer:refreshed', scheduleSync);

  document.addEventListener(
    'transitionrun',
    (event) => {
      if (event.propertyName !== 'transform') return;
      if (!(event.target instanceof Element) || !event.target.closest(HEADER_GROUP)) return;
      followHeaderMotion();
    },
    true
  );

  if (typeof ResizeObserver === 'function') {
    const resizeObserver = new ResizeObserver(scheduleSync);
    document.querySelectorAll(HEADER_GROUP).forEach((el) => resizeObserver.observe(el));
  }

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('cart-drawer').then(() => {
      observeDrawer(document.getElementById('cart-drawer'));
      scheduleSync();
    }).catch(() => {});
  }
})();

(() => {
  /* 头部角标跟心愿页同一套数据：按 SKC（productId:variantId）计数。
     应用自己的 xb_multi_wishlists.itemCount 会把变体数或历史残留算进去，和 GET tools/xb-wishlist 对不上。 */
  const LS_DATA = 'xb_wishlist_data';
  const LS_KEYS = 'xb_wishlist_all_product_keys';
  const QTY_SELECTOR = '[data-header-wishlist-count], .header__wishlist-link .xb-product-quantity';

  const parse = (raw, fallback) => {
    try {
      const value = JSON.parse(raw);
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  };

  const readLocalCount = () => {
    const keys = new Set();
    try {
      const data = parse(localStorage.getItem(LS_DATA), []);
      if (Array.isArray(data)) {
        data.forEach((item) => {
          const productId = String((item && (item.productId || item.product_id)) || '').trim();
          const variantId = String((item && (item.variantId || item.variant_id)) || '').trim();
          if (!/^\d+$/.test(productId)) return;
          keys.add(variantId ? `${productId}:${variantId}` : productId);
        });
      }

      if (!keys.size) {
        const stored = parse(localStorage.getItem(LS_KEYS), {});
        if (stored && typeof stored === 'object') {
          Object.keys(stored).forEach((listId) => {
            (stored[listId] || []).forEach((key) => {
              const parts = String(key).split(':');
              if (!/^\d+$/.test(parts[0])) return;
              keys.add(parts[1] ? `${parts[0]}:${parts[1]}` : parts[0]);
            });
          });
        }
      }
    } catch (error) {
      return 0;
    }
    return keys.size;
  };

  const patchLocalWishlist = () => {
    if (window.__tiemcoWishlistStoragePatched) return;
    window.__tiemcoWishlistStoragePatched = true;

    const original = window.localStorage.setItem.bind(window.localStorage);
    window.localStorage.setItem = function (key, value) {
      const prev = window.localStorage.getItem(key);
      original(key, value);
      if (key && String(key).indexOf('xb_wishlist') === 0 && prev !== String(value)) {
        document.dispatchEvent(new CustomEvent('xb-wishlist:local-change'));
      }
    };
  };

  let syncing = false;
  let timer = 0;

  const paint = () => {
    const count = readLocalCount();
    const text = count > 0 ? String(count) : '';
    syncing = true;
    document.querySelectorAll(QTY_SELECTOR).forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.textContent !== text) el.textContent = text;
      el.classList.toggle('show', count > 0);
      el.toggleAttribute('data-header-wishlist-ready', true);
    });
    syncing = false;
  };

  const schedulePaint = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(paint, 50);
  };

  const bind = (el) => {
    if (!(el instanceof HTMLElement) || el.hasAttribute('data-header-wishlist-bound')) return;
    el.setAttribute('data-header-wishlist-bound', '');
    new MutationObserver(() => {
      if (syncing) return;
      paint();
    }).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const scan = () => {
    document.querySelectorAll(QTY_SELECTOR).forEach(bind);
    paint();
  };

  patchLocalWishlist();
  scan();
  new MutationObserver(() => {
    document.querySelectorAll(QTY_SELECTOR).forEach(bind);
  }).observe(document.documentElement, { childList: true, subtree: true });

  ['xb-wishlist:local-change', 'xb-wishlist:update-state', 'xb-wishlist:remove', 'cart:move-to-wishlist'].forEach(
    (name) => document.addEventListener(name, schedulePaint)
  );
  window.addEventListener('storage', (event) => {
    if (!event.key || event.key.indexOf('xb_wishlist') !== 0) return;
    schedulePaint();
  });
})();
